import BaseApplication from "pages/BaseApplication"
// import Details from "./Details"
import AssignStaff from "../AssignStaff/index"
import { useEffect, useState } from "react"

import Application from "services/applications/Application.service"
import Details from "./Details"

const loggedInUser = JSON.parse(localStorage.getItem("authUser"))
const appService = new Application(loggedInUser)

const EnvironmentalAuditRequest = props => {
  const [loading, setloading] = useState(false)
  const [success, setsuccess] = useState(false)
  const [error, seterror] = useState(false)

  // console.log("Data", props.appDetails)
  const assignApplicationToOfficer = formData => {
    if (confirm("Proceed to assign staff to application?")) {
      setloading(true)
      appService.assignStaff(formData).then(response => {
        if (response.status) {
          // alert("Officer successfully assigned")
          seterror(false)
          setsuccess(true)
          setloading(false)
        } else {
          // console.log(response)
          setloading(false)
          seterror(true)
          setsuccess(false)
        }
      })
    }
  }
  return (
    <>
      <BaseApplication
        submit={assignApplicationToOfficer}
        title={"Assign Staff"}
        attachments={props.appDetails.application_attachments}
        formComponent={
          <AssignStaff
            loading={loading}
            success={success}
            error={error}
            department={props.appDetails.service.department_id}
            appDetails={{
              applicationId: props.appDetails.id,
              assignedBy: loggedInUser.id,
            }}
          />
        }
        appDetails={<Details appDetails={props.appDetails} />}
        applicationData={props.appDetails}
      />
    </>
  )
}

export default EnvironmentalAuditRequest
